
const state = {
  id: null,
  publication_option_id: undefined,
  title: '',
  value: '',
}

export const requiredFields = [
  { key: 'publication_option_id' },
  { key: 'title' },
  { key: 'value' },
]

export default state
